import React from "react"
import PropTypes from "prop-types"
import {Link} from "react-router"
import {Button, Col} from "elemental"
import Price from "../Price/Price"
import "./ProductCol.scss"
import ButtonLove from "../Button/ButtonLove"
import shop from "../../shop/shop"

const ProductCol = (props) => {
  let {product, sm, md, xs, lg} = props
  return (
    <Col {...{
      sm,
      md,
      xs,
      lg
    }}
         className="product product-col5 product-col">
      {/*<div className="badge badge-neu"><span>NEU</span></div>*/}
      <div className="image tc">
        <Link to={`/product/${product.map_id}`}>
          <img src={product.img_src}
               alt="..."
               title=""
               className="img-responsive" />
        </Link>
      </div>
      <div className="caption tc">
        <div className="brand">{ product.extras.herst !== "unbekannt" ? <Link to={`/brand/${product.extras.herst}`}>{product.extras.herst}</Link> : null}</div>
        <div className="title"><Link to={`/product/${product.map_id}`}>{product.title}</Link></div>
        {shop.session && <div className="price">
          <Price>{product.price}</Price>
        </div>}
        {shop.session && <div>
          <ButtonLove
            className="absolute bottom-1 left-1"
            list={shop.orderlist.default}
            elementInActive={<Button type="link"><i className="icon icon-circle-thin" />{translate("orderlist.on_orderlist")}</Button>}
            elementActive={<Button type="link"><i className="icon icon-circle" />{translate("orderlist.on_orderlist")}</Button>}
            product={product} />

          <Button className="fr"
                  onClick={() => {
                    product.count = 1
                    shop.cart.add(product)
                  }}> <i className="icon icon-basket" /> </Button>

        </div>}
      </div>
    </Col>
  )
}

ProductCol.defaultProps = {
  xs:         "1/2",
  sm:         "1/3",
  md:         "1/5",
  lg:         "1/5",
  quickorder: false
}

ProductCol.propTypes = {
  quickorder: PropTypes.any,
  list:       PropTypes.object,
  product:    PropTypes.object,
  xs:         PropTypes.string,
  sm:         PropTypes.string,
  md:         PropTypes.string,
  lg:         PropTypes.string,
}

export default ProductCol



// WEBPACK FOOTER //
// ./src/components/Product/ProductCol.js